import { UserRole, ContextLike } from "@kazoohr/types";

export function buildYeiHeaders({
  token,
  context,
}: {
  token?: string;
  context?: ContextLike;
}) {
  const headers: Record<string, string> = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  if (
    context?.claims?.robot ||
    // We guard here because this is used in packages/graphql/src/loadRemoteSchema/loadRemoteSchema.ts
    // That file uses a type that's defined by the gql package, so it's this is for safety.
    context?.maybeGetUser?.()?.roles?.includes(UserRole.PLATFORM_ADMIN) ||
    context?.maybeGetUser?.()?.roles?.includes(UserRole.SUPERADMIN)
  ) {
    headers["bypass-maintenance"] = "true";
  }

  return headers;
}
